import { render, staticRenderFns } from "./SimpleCardSkeleton.vue?vue&type=template&id=6844ac3a&scoped=true"
import script from "./SimpleCardSkeleton.vue?vue&type=script&lang=js"
export * from "./SimpleCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./SimpleCardSkeleton.vue?vue&type=style&index=0&id=6844ac3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6844ac3a",
  null
  
)

export default component.exports